/**
 * Do not edit directly
 * Generated on Wed, 17 Apr 2024 09:25:55 GMT
 */

export const SDS_BRAND_META_NAME = "S-pankki brand";
